module.exports = __webpack_public_path__ + "img/20200620_094323.be150d0b.jpg";